export const formatDate = (date: string) => {
  if (!date) {
    return '';
  }

  const [day, month, year] = date.split('/');

  const formattedDate = `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`.split(' ')[0];

  return formattedDate;
};
